import { TeamMemberRole, TeamMemberStatus } from '__generated__/GQL';
import { MembersTab } from 'features/Team/routes';

export type RoleWithoutAccountHolder =
  | Exclude<TeamMemberRole, TeamMemberRole.AccountHolder | TeamMemberRole.None>
  | TeamMemberStatus.Locked;

export const filterToTab: Record<RoleWithoutAccountHolder, MembersTab> = {
  [TeamMemberRole.Accountant]: 'accountants',
  [TeamMemberRole.Admin]: 'admins',
  [TeamMemberRole.Employee]: 'employees',
  [TeamMemberStatus.Locked]: 'locked',
};

export const tabToFilter: Record<MembersTab, RoleWithoutAccountHolder | null> =
  {
    accountants: TeamMemberRole.Accountant,
    admins: TeamMemberRole.Admin,
    all: null,
    employees: TeamMemberRole.Employee,
    locked: TeamMemberStatus.Locked,
  };
